module.exports = __webpack_public_path__ + "static/img/img-norty.2de79e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/img-norty.png
// module id = b1uo
// module chunks = 134